import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { getRank, menageRank } from './rank.interface';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConvertService } from 'src/app/services/convert.service';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-rank',
  templateUrl: './rank.component.html',
  styleUrls: ['./rank.component.scss']
})
export class RankComponent {
  contentRank = environment.contentRank
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private con: ConvertService,
    private alert: AlertService
  ) {
    this.getRank();
  }

  formRank: FormGroup | any = this.fb.group(<menageRank>{
    Rank_id: 0,
    Rank_name: '',
    Rank_point: '',
    Rank_image: '',
    Rank_image_update: '',
    Rank_image_delete: '',
  })

  upRank() {
    this.http.get(`rank/updaterank`).subscribe({
      next: (res: any) => {
        this.rankItems = res.data;
      }
    })
  }

  rankItems!: getRank[]
  getRank() {
    this.http.get(`Rank`).subscribe({
      next: (res: any) => {
        this.rankItems = res.data;
      }
    })
  }

  message: string = ""
  manageRank: boolean = false
  addStatus: boolean = false;
  addRank() {
    this.message = "เพิ่ม RANK"
    this.manageRank = true
    this.addStatus = true;
  }

  updateStatus: boolean = false;
  updateItems!: getRank
  viewRank(item: getRank) {
    this.formRank.patchValue(item)
    this.message = "แก้ไข RANK"
    this.manageRank = true
    this.updateStatus = true;
  }



  viewImage: string = ""
  uploadFile(e: any) {
    let item: getRank = this.formRank.value;
    this.formRank.get('Rank_image_delete').setValue(item.Rank_image)
    this.formRank.get('Rank_image_update').setValue(e.file)
    this.viewImage = e.base64
  }


  createRank() {
    this.http.post(`rank`, this.con.paseFormData(this.formRank.value)).subscribe({
      next: (res: any) => {
        this.getRank()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {

        this.clearEvent()
      }
    })
  }

  updateRank() {
    this.http.put(`rank/update/${this.formRank.value['Rank_id']}`, this.con.paseFormData(this.formRank.value)).subscribe({
      next: (res: any) => {
        this.getRank()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {
        this.clearEvent()
      }
    })
  }

  deleteRank(item: getRank) {
    let model = {
      Rank_id: item.Rank_id,
      Rank_image_delete: item.Rank_image
    }
    this.alert.confirm('ต้องการลบ RANK นี้หรือไม่').then(fm => {
      if (fm.isConfirmed) this.http.put(`rank/delete`, model).subscribe({
        next: (res: any) => {
          this.getRank()
          this.alert.notify(res.message, 'success')
        },
        error: (err) => {
          this.alert.dialog(err.error.message)
        },
        complete: () => {

          this.clearEvent()
        }
      })
    })

  }

  clearEvent() {
    this.formRank.reset()
    this.viewImage = ""
    this.message = ""
    this.manageRank = false
    this.addStatus = false;
    this.updateStatus = false;
  }
}
